export const transformSearchKeywordItemsForDropdown = (listings = {}, keywords = []) => {
    const specialties =
        keywords &&
        keywords.filter &&
        keywords.filter(item =>item.type === 'specialty' &&  listings.specialties.find(specialty => specialty.id === item.id)
        ).map(keyword =>
            ({
                ...keyword,
                isTopLevelSpecialty: keyword.parent_name === 'abstract_top_level_keyword'
            })) || [];

    const otherKeywords =
        keywords &&
        keywords.filter &&
        keywords
            .filter(item => item.type === 'condition' && listings.conditions.find(kw => kw.id === item.id))
            .concat(keywords.filter(item => item.type === 'procedure' && listings.procedures.find(kw => kw.id === item.id)))
            || [];

    const specialists = keywords && keywords.filter && keywords.filter(item => item.type === 'specialist').map(item => ({
        ...item,
        renderAsProfile: true,
    })) || [];

    return [
        ...specialties,
        ...otherKeywords,
        ...specialists
    ];
};



// WEBPACK FOOTER //
// ./src/client/utils/transformers/transformSearchKeywordItemsForDropdown.js